export default __webpack_public_path__ + "static/media/DashboardLogistica3.f5e7aebb.png";